import { QueryResult } from "../../../Common/domain/src/api/queryResult";

//TOKEN FLOW
export const TOKEN_FLOW = "TOKEN_FLOW";
export const TOKEN_FLOW_FAIL = "TOKEN_FLOW_FAIL";
export interface GetTokenFlowState {
  loggedUser: QueryResult;
}

export interface GetTokenFlowType {
  type: typeof TOKEN_FLOW | typeof TOKEN_FLOW_FAIL;
  payload: QueryResult;
}
export type TokenFlowType = GetTokenFlowType;
 